import { useState, useEffect, useCallback, createContext, useContext, ReactNode } from 'react';

const DEFAULT_LANGUAGE = 'pt-BR';
const LOCAL_STORAGE_KEY = 'selectedLanguage';

interface LanguageContextType {
  selectedLanguage: string;
  setLanguage: (languageCode: string) => void;
}

interface NoPCDContextType {
  noPCD: boolean;
  setNoPCD: (value: boolean) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
const  NoPCDContext = createContext< NoPCDContextType | undefined>(undefined);

const useLanguagePreference = () => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(() => {
    if (typeof window !== 'undefined') {
      const storedLanguage = localStorage.getItem(LOCAL_STORAGE_KEY);
      return storedLanguage || DEFAULT_LANGUAGE;
    }
    return DEFAULT_LANGUAGE;
  });


  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(LOCAL_STORAGE_KEY, selectedLanguage);
    }
  }, [selectedLanguage]);
  
  const setLanguage = useCallback((languageCode: string) => {
    setSelectedLanguage(languageCode);
  }, []);
  
  return { selectedLanguage, setLanguage };
};

const useNoPCDPreference = () => {
const [selectedNoPCD, setSelectedNoPCD] = useState<boolean>(false);

const setNoPCD = useCallback((value: boolean) => {
  setSelectedNoPCD(value);
}, []);

return { selectedNoPCD, setNoPCD };
};

interface LanguageProviderProps {
  children: ReactNode;
}

interface NoPCDProviderProps {
  children: ReactNode;
}

export const LanguageProvider = ({ children }: LanguageProviderProps) => {
  const { selectedLanguage, setLanguage } = useLanguagePreference();

  return (
    <LanguageContext.Provider value={{ selectedLanguage, setLanguage }}>
      <NoPCDProvider>{children}</NoPCDProvider>
    </LanguageContext.Provider>
  );
};

export const NoPCDProvider = ({ children }: NoPCDProviderProps) => {
  const { selectedNoPCD, setNoPCD } = useNoPCDPreference();

  return (
    <NoPCDContext.Provider value={{ noPCD: selectedNoPCD, setNoPCD }}>
      {children}
    </NoPCDContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage deve ser usado dentro de um LanguageProvider');
  }
  return context;
};

export const useNoPCD = (): NoPCDContextType => {
  const context = useContext(NoPCDContext);
  if (context === undefined) {
    throw new Error('useNoPCD deve ser usado dentro de um NoPCDProvider');
  }
  return context;
};